import { FC, useEffect, useState } from 'react';
import { noInputTimeoutOverrideDefaults } from '../../const/design';
import { DesignChannelType, DesignNoInputTimeoutOverride } from '../../types';
import { validateInput, isNumberRules, isVariableRules } from '../../utilities/functions/validations';
import Textarea from '../Textarea';
import style from './no-input-timeout-override.module.scss';

export type NoInputTimeoutProps = {
  onValueChange: (
    value: DesignNoInputTimeoutOverride,
    oldValue: DesignNoInputTimeoutOverride
  ) => void;
  value: DesignNoInputTimeoutOverride;
  showGlobals?: boolean;
  excludeChannels?: DesignChannelType[];
};

export const NoInputTimeoutOverride: FC<NoInputTimeoutProps> = ({
  onValueChange,
  value: defaultTimeoutOverrides,
  excludeChannels = []
}) => {
  // This is needed because node models do not use state in the property panels.
  const [timeoutOverrides, setTimeoutOverrides] = useState(defaultTimeoutOverrides);
  const { channelTypeOptions } = window.apm.getChannelOptions();

  useEffect(() => {
    setTimeoutOverrides(defaultTimeoutOverrides);
  }, [defaultTimeoutOverrides]);

  const handleOnChange = (value: string, channel: DesignChannelType) => {
    const newTimeoutOverrides = { ...timeoutOverrides };
    if (!value) {
      delete newTimeoutOverrides[channel];
    } else {
      newTimeoutOverrides[channel] = value;
    }
    setTimeoutOverrides(newTimeoutOverrides);
    onValueChange(newTimeoutOverrides, timeoutOverrides);
  };

  return (
    <>
      {channelTypeOptions.filter(({ value }) => {
        return (
          window.apm.serialized.omniChannel.isOmniChannel ? (
            !excludeChannels.includes(value)
          ) : value === DesignChannelType.voice
        );
      }).map(({ name: channelName, value: channel }) => {
        const value = timeoutOverrides?.[channel] ?? '';
        const globalValue = window.apm.serialized.rootSettings?.noInputTimeoutOverride?.[channel];
        const defaultValue = noInputTimeoutOverrideDefaults?.[channel] ?? noInputTimeoutOverrideDefaults.default;
        const placeholder = (globalValue) ? `Global: ${globalValue} ms.` : `Default: ${defaultValue} ms.`;
        return (
          <Textarea
            key={channel}
            valKey={channel}
            label={channelName}
            value={value}
            highlight
            isPropertyPanel
            onChange={(value: string) => handleOnChange(value, channel)}
            rows={/[{}]/.test(value?.toString()) ? 2 : 1}
            style={{ resize: 'none', minHeight: 'auto' }}
            spellCheck={false}
            valRules={{ _: (value: string) => validateInput(value, [isVariableRules, isNumberRules]) }}
            placeholder={placeholder}
            className={style['container']}
          />
        );
      })}
    </>
  );
};
